// Header navigation data — module-level constants extracted from Header.js
// so the orchestrator component stays small and the data is testable / reusable.

export const NAV_MENUS = {
  platform: {
    label: 'Platform',
    hubHref: '/platform',
    hubLabel: 'See the platform',
    items: [
      { label: 'MCX Core', href: '/platform/mcx-core', desc: 'Core network infrastructure and subscriber management' },
      { label: 'MCX BSS', href: '/platform/mcx-bss', desc: 'Cloud-native billing, charging, and customer management' },
      { label: 'MCX Activate', href: '/platform/mcx-activate', desc: 'SIM, eSIM, KYC, and subscriber onboarding' },
      { label: 'MCX Marketplace', href: '/platform/mcx-marketplace', desc: 'B2B2X marketplace for digital services beyond connectivity' },
    ],
  },
  solutions: {
    label: 'Solutions',
    items: [
      { label: 'Banks & Fintechs', href: '/solutions/banks-and-fintechs', desc: 'Mobile services for licensed Nigerian financial institutions' },
      { label: 'Consumer Brands', href: '/solutions/consumer-brands', desc: 'Mobile for retail and loyalty-programme operators' },
      { label: 'Enterprise & Corporate', href: '/solutions/enterprise-and-corporate-affinity', desc: 'Mobile for enterprise groups and corporate networks' },
      { label: 'Diaspora & Affinity', href: '/solutions/diaspora-and-affinity', desc: 'Mobile services for niche and affinity audiences' },
      { label: 'IoT & M2M', href: '/solutions/iot-and-m2m', desc: 'Connected device and M2M connectivity' },
      { label: 'Foreign MVNO Landing', href: '/solutions/foreign-mvno-landing', desc: 'Nigeria market entry for foreign mobile operators' },
    ],
  },
  regulatory: {
    label: 'Regulatory',
    items: [
      { label: 'NCC MVNO Framework', href: '/regulatory/ncc-mvno-framework', desc: 'Five-tier NCC licensing structure and compliance' },
      { label: 'NDPA & Data Protection', href: '/regulatory/ndpa-and-data-protection', desc: 'Nigeria Data Protection Act 2023 obligations' },
      { label: 'SIM Registration & KYC', href: '/regulatory/sim-registration-and-kyc', desc: 'NIN-based SIM registration requirements' },
      { label: 'Lawful Intercept', href: '/regulatory/lawful-intercept', desc: 'Regulatory intercept obligations for MVNOs' },
      { label: 'Trust', href: '/trust', desc: 'SLA targets, security posture, certifications, and incident response' },
    ],
  },
  about: {
    label: 'About',
    hubHref: '/about',
    hubLabel: 'About MobileCoreX',
    items: [
      { label: 'Who we are', href: '/about/who-we-are', desc: 'The institutional MVNE platform for Nigerian telecoms' },
      { label: 'What we do', href: '/about/what-we-do', desc: 'The platform layer between Nigerian MNOs and institutional MVNOs' },
      { label: 'How we do it', href: '/about/how-we-do-it', desc: 'The MCX operating model and regulatory positioning' },
      { label: 'Leadership', href: '/about/leadership', desc: 'The team building the platform' },
      { label: 'Company facts', href: '/about/company-facts', desc: 'RC, address, regulatory positioning, capital structure' },
    ],
  },
};

export const SINGLE_LINKS = [
  { label: 'News and insights', href: '/news-and-insights' },
  { label: 'Partners', href: '/partners' },
  { label: 'Launch an MVNO', href: '/launch-an-mvno' },
];

const MEGA_MENU_COLS = {
  solutions: 'grid-cols-2 md:grid-cols-3',
  platform: 'grid-cols-2 md:grid-cols-4',
  about: 'grid-cols-2 md:grid-cols-5',
  regulatory: 'grid-cols-2 md:grid-cols-5',
};
export const getMegaMenuCols = (key) => MEGA_MENU_COLS[key] || 'grid-cols-2 md:grid-cols-4';

// Routes whose hero is full-bleed dark immediately under the header.
// On these pages the header may be transparent at scroll 0. Everywhere
// else (pages that render the white Breadcrumb at the top) the header
// must stay solid so the nav remains legible.
export const TRANSPARENT_AT_TOP_ROUTES = new Set(['/', '/book-a-call']);
